import { InfosecLevel } from "@istari-frontend/resource/model";
import { V3Models } from "@istari/istari-client";

export function toInfosecLevel(sdkLevel: V3Models.InfosecLevel | null | undefined): InfosecLevel | undefined {
  if (!sdkLevel) {
    return undefined;
  }

  return {
    id: sdkLevel.id,
    name: sdkLevel.name,
    order: sdkLevel.order,
    displayColor: sdkLevel.displayColor,
  };
}
